/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */

export type InputsInputBindingActionType =
  (typeof InputsInputBindingActionType)[keyof typeof InputsInputBindingActionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InputsInputBindingActionType = {
  InputBindingActionSceneActivate: 'scene.activate',
  InputBindingActionSceneDeactivate: 'scene.deactivate',
  InputBindingActionSceneToggle: 'scene.toggle',
  InputBindingActionDeviceState: 'device.state',
  InputBindingActionDeviceCommand: 'device.command',
} as const;
